document.addEventListener('DOMContentLoaded', function () {
  const productHandle = '{{ product.handle }}'; // Current product handle
  const productTitle = '{{ product.title }}'; // Current product title
  const productImage = '{{ product.featured_image | image_url: "200x200" }}'; // Current product image
  const productUrl = '{{ product.url }}'; // Current product URL

  // Function to get cookies
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  // Function to set cookies
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
  }

  // Get the recently viewed products from cookies
  let recentlyViewed = getCookie('recentlyViewed');
  recentlyViewed = recentlyViewed ? JSON.parse(recentlyViewed) : [];

  // Check if the current product is already in the list
  const existingProduct = recentlyViewed.find((product) => product.handle === productHandle);

  if (!existingProduct) {
    // Add the current product to the beginning of the list
    recentlyViewed.unshift({
      handle: productHandle,
      title: productTitle,
      image: productImage,
      url: productUrl,
    });

    // Limit the list to 5 products
    if (recentlyViewed.length > 5) {
      recentlyViewed.pop();
    }

    // Save the updated list back to cookies
    setCookie('recentlyViewed', JSON.stringify(recentlyViewed), 7); // Store for 7 days
  }
});